import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, isRef as _isRef, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-39e9d804"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "order-number-point"
}
const _hoisted_2 = { class: "style-tip-icon" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "iconfont icon-wenhao_tianchong" }, null, -1))
const _hoisted_4 = {
  key: 1,
  class: "flex order-status background-white"
}
const _hoisted_5 = { style: {"word-break":"break-word"} }
const _hoisted_6 = { class: "flexcenter" }
const _hoisted_7 = { style: {"flex":"1","word-break":"break-word"} }
const _hoisted_8 = { style: {"word-break":"break-word"} }
const _hoisted_9 = {
  class: "flex-bwn-wrap",
  style: {"padding":"4px 0","width":"100%"}
}
const _hoisted_10 = { class: "flexcenter" }
const _hoisted_11 = { style: {"flex":"1","word-break":"break-word"} }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = {
  class: "flex-bwn-wrap",
  style: {"padding":"4px 0","width":"100%"}
}
const _hoisted_16 = { class: "el-dialog__body-title" }
const _hoisted_17 = { style: {"padding":"20px","background-color":"#fff"} }
const _hoisted_18 = {
  key: 0,
  style: {"padding-bottom":"20px"}
}
const _hoisted_19 = { style: {"margin-right":"20px"} }
const _hoisted_20 = { style: {"margin-top":"20px","font-size":"16px"} }
const _hoisted_21 = { class: "footer flex-ter-end" }

import { t } from '@/plugins/i18n'
import { ref, computed, nextTick, toRaw, watch, onMounted, onUnmounted } from 'vue'
import STable from '@/components/Table/index.vue'
import SSearch from './Search.vue'
import AppLink from '@/components/common/AppLink.vue'
import memberEventBox from '@/components/common/MemberEventBox.vue'
import CommonTip from '@/components/CommonTip/index.vue'
import {
  editableTabs, storeColumns, tableConfig, tableConfigSku, deliveryTypeOption,
  thirdWarehouseTypeDict, deliveryStatusDict, confirmOrderColumns, confirmSkuColumns,
  confirmSkuSecondColumns
  , changeReasonCodes,
  confirmTypes
} from './data'
import { jpWareInfo } from '@/common/const'

import ShoppingPreview from '@/components/common/ShoppingPreview.vue'
import { useRtfix, isJA, useSite, isD2C, isMultiStore, useUser } from '@/store'
import useTabData from '@/util/useTabData'
import { setNoEmptyForm, getJapanTime } from '@/util/common'
import { getDeliveryPage, cancelDelivery, signDelivery, getTrack, getProcessByOrderPage, getProcessBySkuPage, getNoticeCount } from '@/apis/inShipping'
import AfterSalesDialog from './AfterSalesDialog/index.vue'
import TrackDialog from './TrackDialog/index.vue'
import Guide from '@/components/guide/index.vue'
import UploadDialog from './uploadDialog/index.vue'
import ProblemHandlingOrder from './ProblemHandlingOrder/index.vue'
import ProblemHandlingResult from './ProblemHandlingResult/index.vue'
import { getCustomerShop, intShipConfigGetForwarders } from '@/apis/order'
import { useRouter, useRoute } from 'vue-router'
import { useStore } from 'vuex'
import { ElMessageBox, ElMessage } from 'element-plus'
import CopyButton from '@/components/common/CopyButton.vue'
import BatchSearch from '@/components/BatchSearch/index.vue'
import bus from '@/util/useBus'
import useEchart, { getVisitorTicketListResult, VisitorTicketListResultItem } from '@/util/useEchart'
import EchartBtn from '@/components/common/EchartBtn.vue'
import axios from 'axios'
import { request } from '@/config/request/interceptors'
import FreeShipping from '@/views/goods/components/FreeShipping.vue'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const user = useUser()
const wareType = ref('CN')
const store = useStore()
const sendTypeVisible = ref(false)
const isAmazon = ref()

const diffD2C = (col: any[]) => {
  const isd2c = isD2C()
  const filter_keys = ['deliveryTitle', 'thirdWarehouseType']
  return isd2c ? col.filter(v => !filter_keys.includes(v.prop)) : col
}

onMounted(() => {
  if (store.getters.isLogin) {
    getCustomerShop({}).then((res: any) => {
      if (res.success) {
        isAmazon.value = res.data.customerShopPlatform === 4 && res.data.customerShopAuthStatus
      }
    })
  }
})
const router = useRouter()
const route = useRoute()
const openCreateType = () => {
  if (isD2C()) {
    router.push(useRtfix('StockJp'))
    return
  }
  if (!isJA()) {
    router.push(useRtfix('CreateShipping', { params: { sendType: 0 } }))
    return
  }
  if (isAmazon.value) {
    createType.value = 1
    // createTypeVisible.value = true
  } else {
    createType.value = 2
    // sendTypeVisible.value = true
    // router.push(useRtfix('CreateShipping'))
  }
  wareType.value = 'CN'
  createTypeVisible.value = true
}
// const abc =

const customerShopName = computed(() => store.getters.shopname)
const noticeCount = computed(() => {
  return toRaw(store.getters.shippingListNum) ?? {}
})
onMounted(async () => {
  // 页面初始化时
  if (tabData.value === 'all') {
    const { data } = await getNoticeCount({})
    store.commit('route/shippingListNum', data)
  }
})
const dataListener = async () => {
  // 当为待确认tab，才需要监听
  if (tabData.value === 'ConfirmType') {
    const { data } = await getNoticeCount({})
    store.commit('route/shippingListNum', data)
  }
}

// 创建发货类型选择弹窗
const createTypeVisible = ref(false)
const createType = ref(1)
const sendType = ref(2)
const STableRef = ref()

const chooseCall = () => {
  router.push(useRtfix('CreateShipping', { params: { sendType: sendType.value, wareType: wareType.value } }))
}
/** 给子表格排序，有变更理由的放在前面 */
const getTableSon = (table: any) => {
  const arr = table?.toSorted((a: any, b: any) => {
    // 原运输方式和建议运输方式相同的放在后面
    const _aChangecode = a.changeReasonCode === 'AR_0000' || a.confirmType !== confirmTypes.Unconfirmed ? '' : a.changeReasonCode
    const _bChangecode = b.changeReasonCode === 'AR_0000' || b.confirmType !== confirmTypes.Unconfirmed ? '' : b.changeReasonCode
    return Number(Boolean(_bChangecode)) - Number(Boolean(_aChangecode))
  })
  return arr
}
const refreshTable = (type?: boolean) => {
  if (type) {
    pageData.value = {
      page: 1,
      limit: 30
    }
  }
  nextTick(() => {
    STableRef.value && STableRef.value.getData()
  })
}
/** 问题处理弹窗visible */
const orderVisible = ref(false)
/** 问题处理结果弹窗visible */
const resultVisible = ref(false)
/** sku问题处理拆单之后返回的编号 */
const resultData = ref([])
/** 开-关 问题处理弹窗 */
const changeOrderVisible = (obj: { visible: boolean, isNeedWatch?: boolean, data?: any }, row?: any) => {
  const { visible, isNeedWatch = false, data = [] } = obj
  orderVisible.value = visible
  if (!row) {
    rowItem.value = {}
    return
  }
  if (isNeedWatch) {
    resultVisible.value = true
    rowItem.value = {}
    // 拷贝下
    const _data = data?.length > 0 ? JSON.parse(JSON.stringify(data)) : []
    resultData.value = _data
    return
  }
  rowItem.value = row
}
/**  */
const changeresultVisible = (val: boolean, row?: any) => {
  resultVisible.value = val
  // if (!row) {
  //   rowItem.value = {}
  //   return
  // }
  // rowItem.value = row
}
/** 获取变更理由 */
const getChangeReasonCodes = (row: any) => {
  // 确认类型(0:未确认 1:接受 2:取消订单 3:拒绝按照原来方式运输)
  if (row.confirmType !== confirmTypes.Unconfirmed) {
    return '-'
  }
  if (changeReasonCodes[row.changeReasonCode]) {
    return changeReasonCodes[row.changeReasonCode]
  }
  return '-'
}

const pageData = ref({
  page: 1,
  limit: 30
})

const searchForm = ref<any>({})
const confirmType = ref<any>('ORDER')

// 消息回显
if (route.query.deliveryTaskCode) {
  searchForm.value.deliveryTaskCode = route.query.deliveryTaskCode
}
/** */
if (route.query.confirmTypeValue) {
  confirmType.value = route.query.confirmTypeValue
}
watch(() => route.query.deliveryTaskCode, (val) => {
  // 如果是国际发货管理，且为待处理的tab，且该字段有值
  if (val && route.query.deliveryStatus === '0,1,2,3,4' && route.name === 'ShippingList_b2b') {
    location.reload()
  }
})
const { tabData, deliveryStatus } = useTabData({ TabName: 'deliveryStatus' }, () => {
  // 不然待确定tab会请求两次
  if (deliveryStatus.value !== 'ConfirmType') {
    refreshTable(true)
  }
}) as any

const filterData = computed(() => {
  const value = setNoEmptyForm(toRaw(searchForm.value))
  let params: any = { ...value }
  if (deliveryStatus.value === 'ConfirmType') {
    params = {
      ...value,
      deliveryTaskCodeList: value?.deliveryTaskCode ? [value?.deliveryTaskCode] : undefined,
      // 当为待确认tab下不用这个字段，用上面的
      deliveryTaskCode: undefined
    }
  }
  if (deliveryStatus.value.includes(',')) {
    params.deliveryStatusList = deliveryStatus.value.split(',')
  } else {
    params.deliveryStatus = deliveryStatus.value
  }
  if (isD2C()) {
    params.overseasInvFlag = 1
  }
  return params
})

const trackVisible = ref(false)
const showTrack = async (row: any) => {
  const res1 = await intShipConfigGetForwarders(row?.intShipConfigId)
  rowItem.value = { ...row.rowData, shipInfo: res1.data, logisticsCode: row.logisticsCode }
  try {
    row.trackLoading = true
    const res = await getTrack({
      deliveryTaskCode: row.deliveryTaskCode,
      logisticsCode: row.logisticsCode
    })
    if (res.data?.taskTrackDTOList?.length) {
      rowItem.value = { ...res.data }
    }
  } catch (error) {
  } finally {
    nextTick(() => {
      row.trackLoading = false
      trackVisible.value = true
    })
  }
}

const rowItem: any = ref({})
const dataList: any = ref([])

const afterSaleVisible = ref(false)
const afterSale = (row: any) => {
  rowItem.value = row
  dataList.value = rowItem.value.taskDetailList
  afterSaleVisible.value = true
}
const applyCancel = async (row: any) => {
  const res = await request.wms.wms.deliveryTaskCheckDiscardPlan({ deliveryTaskCode: row.deliveryTaskCode })
  if (res.success) {
    if (res.data?.length) {
      ElMessageBox.confirm(`
        <div>${t('如果取消当发货单，将会取消以下发货单，是否确定')}</div>
          <div>
          ${res?.data?.map((item) => {
        return `<div>${item}</div>`
      }).join('')}
      </div>
       `, 'ご確認下さい',
        {
          confirmButtonText: t('确定'),
          cancelButtonText: t('取消'),
          dangerouslyUseHTMLString: true,
          type: 'warning'
        })
        .then(() => {
          cancelDelivery({
            deliveryTaskCode: row.deliveryTaskCode
          }).then((res: any) => {
            if (res.success) {
              ElMessage.success(t('申请取消成功'))
              refreshTable()
            }
          })
        })
    } else {
      cancelDelivery({
        deliveryTaskCode: row.deliveryTaskCode
      }).then((res: any) => {
        if (res.success) {
          ElMessage.success(t('申请取消成功'))
          refreshTable()
        }
      })
    }
  }
}

const sign = (row: any) => {
  signDelivery({
    deliveryTaskCode: row.deliveryTaskCode
  }).then((res: any) => {
    if (res.success) {
      ElMessage.success(t('签收成功'))
      refreshTable()
    }
  })
}

const uploadDialog = ref()
// 上传箱唛弹窗
const uploadBoxModal = (row: any) => {
  uploadDialog.value.open(row)
}
const batchSearchParams = ref({})
const isBatchSearch = ref(false) // 是否批量搜索
bus.on('batchSearch', (params: any) => {
  isBatchSearch.value = true
  batchSearchParams.value = params
  if (isD2C()) {
    batchSearchParams.value.overseasInvFlag = 1
  }
  refreshTable(true)
})
/** 搜索 */
const search = () => {
  isBatchSearch.value = false
  refreshTable(true)
}
/** 切换待确认下二级tab */
const switchStatus = (status: string) => {
  if (tabData.value !== 'ConfirmType' || status === confirmType.value) return
  confirmType.value = status
  isBatchSearch.value = false
}
/** 待确认-sku-若是有变更理由则展示不同样式 */
const tableRowClassName = ({ row }: { row: any }) => {
  //   如果建议运输方式和原运输方式一样
  if (row.confirmType !== confirmTypes.Unconfirmed) {
    return ''
  }
  if (row.changeReasonCode && row.changeReasonCode !== 'AR_0000') {
    return 'style-high-light'
  }
  return ''
}

const { language, metaData, companyId } = useEchart()
let timer: NodeJS.Timeout | null = null
const echartRecordList = ref<VisitorTicketListResultItem[]>([])

onMounted(() => {
  const getEchartRecord = async () => {
    const res: getVisitorTicketListResult = (await axios.get(`https://eapi.echatsoft.com/getVisitorTicketList?metaData=${encodeURIComponent(metaData)}&companyId=${companyId}`)).data
    console.log(res)
    if (res.successful) {
      echartRecordList.value = res.result
      console.log(echartRecordList.value, 'echartRecordList')
    }
  }
  if (isJA()) {
    getEchartRecord()
    timer = setInterval(getEchartRecord, 5000)
  }
})

onUnmounted(() => {
  if (timer) {
    clearInterval(timer)
  }
})


return (_ctx: any,_cache: any) => {
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_badge = _resolveComponent("el-badge")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_table_button = _resolveComponent("table-button")!
  const _component_el_popconfirm = _resolveComponent("el-popconfirm")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_unref(isD2C)())
      ? (_openBlock(), _createBlock(CommonTip, {
          key: 0,
          name: 'expressTime,stopWarehouse'
        }))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["shipping-list", _unref(useSite)()])
    }, [
      (_unref(noticeCount)?.totalCount > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_unref(noticeCount)?.totalCount > 99 ? '99+' : _unref(noticeCount)?.totalCount), 1))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_el_tooltip, {
          "popper-class": "style-tip-icon-width",
          effect: "light",
          content: _unref(t)('商品与运输方式不匹配，THE CKB为您推荐了更合适的运输方式，需要您进行确认')
        }, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        }, 8, ["content"])
      ]),
      _createVNode(_component_el_tabs, {
        modelValue: _unref(tabData),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(tabData) ? (tabData).value = $event : null)),
        type: "card",
        class: "demo-tabs"
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(editableTabs), (item) => {
            return (_openBlock(), _createBlock(_component_el_tab_pane, {
              key: item.name,
              label: item.title,
              name: item.name
            }, null, 8, ["label", "name"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["modelValue"]),
      (_unref(deliveryStatus) === 'ConfirmType')
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_component_el_badge, {
              value: _unref(noticeCount)?.byOrderCount > 99 ? '99+' : _unref(noticeCount)?.byOrderCount,
              hidden: _unref(noticeCount)?.byOrderCount <= 0
            }, {
              default: _withCtx(() => [
                _createElementVNode("p", {
                  class: _normalizeClass({ active: confirmType.value === 'ORDER' }),
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (switchStatus('ORDER')))
                }, _toDisplayString(_unref(t)('整单确认')), 3)
              ]),
              _: 1
            }, 8, ["value", "hidden"]),
            _createVNode(_component_el_badge, {
              value: _unref(noticeCount)?.bySkuCount > 99 ? '99+' : _unref(noticeCount)?.bySkuCount,
              hidden: _unref(noticeCount)?.bySkuCount <= 0
            }, {
              default: _withCtx(() => [
                _createElementVNode("p", {
                  style: {"margin-left":"62px"},
                  class: _normalizeClass({ active: confirmType.value === 'SKU' }),
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (switchStatus('SKU')))
                }, _toDisplayString(_unref(t)('按SKU确认')), 3)
              ]),
              _: 1
            }, 8, ["value", "hidden"])
          ]))
        : _createCommentVNode("", true),
      _createVNode(SSearch, {
        form: searchForm.value,
        "onUpdate:form": [
          _cache[3] || (_cache[3] = ($event: any) => ((searchForm).value = $event)),
          search
        ]
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: openCreateType
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(isD2C)() ? '搬送依頼作成' : _unref(t)('创建国际发货')), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["form"]),
      _createVNode(FreeShipping, {
        toCreate: openCreateType,
        scene: 3
      }),
      (_unref(deliveryStatus) === 'ConfirmType')
        ? (_openBlock(), _createBlock(STable, {
            key: confirmType.value,
            ref: (_value, _refs) => {
              _refs['STableRef'] = _value
              STableRef.value = _value
            },
            "page-data": pageData.value,
            "onUpdate:page-data": _cache[4] || (_cache[4] = ($event: any) => ((pageData).value = $event)),
            api: confirmType.value === 'ORDER' ? _unref(getProcessByOrderPage) : _unref(getProcessBySkuPage),
            columns: diffD2C(confirmType.value === 'SKU' ? _unref(confirmSkuColumns) : _unref(confirmOrderColumns)),
            filterData: isBatchSearch.value ? batchSearchParams.value : _unref(filterData),
            tableConfig: confirmType.value === 'ORDER' ? _unref(tableConfig) : _unref(tableConfigSku),
            onDataListener: dataListener
          }, {
            expand: _withCtx(({ scope }) => [
              _createVNode(STable, {
                "table-data": getTableSon(scope.row.skuList),
                columns: _unref(confirmSkuSecondColumns),
                showPagination: false,
                tableRowClassName: tableRowClassName
              }, {
                productImage: _withCtx(({ row }) => [
                  (row.productImage)
                    ? (_openBlock(), _createBlock(ShoppingPreview, {
                        key: 0,
                        image: row.productImage
                      }, null, 8, ["image"]))
                    : _createCommentVNode("", true)
                ]),
                productSkuInfo: _withCtx(({ row }) => [
                  _createElementVNode("div", null, _toDisplayString(row.productSku), 1),
                  _createElementVNode("div", null, _toDisplayString(row.productPropertiesName), 1)
                ]),
                changeReason: _withCtx(({ row }) => [
                  _createElementVNode("div", null, _toDisplayString(getChangeReasonCodes(row)), 1)
                ]),
                recommendDistribution: _withCtx(({ row }) => [
                  _createElementVNode("div", _hoisted_5, _toDisplayString((row.recommendShipConfigId === '-1' ? _unref(t)('无可用运输方式') : (
              row.changeReasonCode === 'AR_0000' || row.confirmType !== _unref(confirmTypes).Unconfirmed ? '-' :
                row.recommendDistribution)) || '-'), 1)
                ]),
                _: 2
              }, 1032, ["table-data", "columns"])
            ]),
            createTime: _withCtx(({ row }) => [
              _createElementVNode("div", null, _toDisplayString(_unref(getJapanTime)(row.createTime)), 1)
            ]),
            deliveryTaskCode: _withCtx(({ row }) => [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("span", _hoisted_7, _toDisplayString(row.deliveryTaskCode), 1),
                _createVNode(CopyButton, {
                  text: row.deliveryTaskCode
                }, null, 8, ["text"])
              ])
            ]),
            thirdWarehouseType: _withCtx(({ row }) => [
              _createTextVNode(_toDisplayString(_unref(thirdWarehouseTypeDict)[row.thirdWarehouseType]), 1)
            ]),
            changeReason: _withCtx(({ row }) => [
              _createElementVNode("div", null, _toDisplayString(_unref(changeReasonCodes)[row.changeReasonCode] || '-'), 1)
            ]),
            recommendDistribution: _withCtx(({ row }) => [
              _createElementVNode("div", _hoisted_8, _toDisplayString((row.recommendShipConfigId === '-1' ? _unref(t)('无可用运输方式') : (
          row.changeReasonCode === 'AR_0000' ? '-' : row.recommendDistribution)) || '-'), 1)
            ]),
            handler: _withCtx(({ scope }) => [
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_table_button, {
                  title: _unref(t)('问题处理'),
                  onClick: _withModifiers(($event: any) => (changeOrderVisible({ visible: true }, scope.row)), ["stop"])
                }, null, 8, ["title", "onClick"]),
                _createVNode(AppLink, {
                  to: _unref(useRtfix)('ShippingInfo', { query: { deliveryTaskCode: scope.row.deliveryTaskCode } })
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_table_button, {
                      title: _unref(t)('详情')
                    }, null, 8, ["title"])
                  ]),
                  _: 2
                }, 1032, ["to"])
              ])
            ]),
            _: 1
          }, 8, ["page-data", "api", "columns", "filterData", "tableConfig"]))
        : (_openBlock(), _createBlock(STable, {
            key: 3,
            ref: (_value, _refs) => {
              _refs['STableRef'] = _value
              STableRef.value = _value
            },
            "page-data": pageData.value,
            "onUpdate:page-data": _cache[5] || (_cache[5] = ($event: any) => ((pageData).value = $event)),
            api: _unref(getDeliveryPage),
            columns: diffD2C(_unref(storeColumns)),
            filterData: isBatchSearch.value ? batchSearchParams.value : _unref(filterData),
            tableConfig: _unref(tableConfig)
          }, {
            createTime: _withCtx(({ row }) => [
              _createElementVNode("div", null, _toDisplayString(_unref(getJapanTime)(row.createTime)), 1)
            ]),
            deliveryTime: _withCtx(({ row }) => [
              _createElementVNode("div", null, _toDisplayString(_unref(getJapanTime)(row.deliveryTime) || '-'), 1)
            ]),
            deliveryTaskCode: _withCtx(({ row }) => [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("span", _hoisted_11, _toDisplayString(row.deliveryTaskCode), 1),
                _createVNode(CopyButton, {
                  text: row.deliveryTaskCode
                }, null, 8, ["text"])
              ])
            ]),
            thirdWarehouseType: _withCtx(({ row }) => [
              _createTextVNode(_toDisplayString(_unref(thirdWarehouseTypeDict)[row.thirdWarehouseType]), 1)
            ]),
            deliveryStatus: _withCtx(({ row }) => [
              _createTextVNode(_toDisplayString(_unref(deliveryStatusDict)[row.deliveryStatus]), 1)
            ]),
            shippingtype: _withCtx(({ row }) => [
              (row.allIncludeFlag === 1 && !row.wmsDistribution)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(row.transportType === 1 ? _unref(t)('海运') : _unref(t)('空运')), 1))
                : (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(row.wmsDistribution ?? ''), 1))
            ]),
            logisticsDetailList: _withCtx(({ row }) => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((row.logisticsDetailList || []), (v) => {
                return (_openBlock(), _createElementBlock("p", {
                  key: v.deliveryTaskLogisticsDetailId,
                  class: "flexcenter"
                }, [
                  _createElementVNode("a", {
                    onClick: ($event: any) => (showTrack({ ...v, rowData: row, deliveryTaskCode: row.deliveryTaskCode, intShipConfigId: row.intShipConfigId })),
                    style: {"overflow":"hidden","word-break":"break-word"}
                  }, _toDisplayString(v.logisticsCode), 9, _hoisted_14),
                  _createVNode(CopyButton, {
                    style: {"margin-left":"2px"},
                    text: v.logisticsCode
                  }, null, 8, ["text"])
                ]))
              }), 128))
            ]),
            handler: _withCtx(({ scope }) => [
              _createElementVNode("div", _hoisted_15, [
                (_unref(isJA)())
                  ? (_openBlock(), _createBlock(EchartBtn, {
                      key: 0,
                      title: _unref(t)('国际物流单号'),
                      list: echartRecordList.value,
                      metaData: _unref(metaData),
                      companyId: _unref(companyId),
                      orderNo: scope.row.deliveryTaskCode,
                      bizType: 2
                    }, null, 8, ["title", "list", "metaData", "companyId", "orderNo"]))
                  : _createCommentVNode("", true),
                (scope.row.deliveryStatus === 4 && (scope.row.thirdWarehouseType === 3 || scope.row.thirdWarehouseType == 4))
                  ? (_openBlock(), _createBlock(_component_table_button, {
                      key: 1,
                      title: scope.row.boxMarkLink ? _unref(t)('修改箱唛') : _unref(t)('上传箱唛'),
                      onClick: ($event: any) => (uploadBoxModal(scope.row))
                    }, null, 8, ["title", "onClick"]))
                  : _createCommentVNode("", true),
                (scope.row.deliveryStatus == 0 || scope.row.deliveryStatus == '-1')
                  ? (_openBlock(), _createBlock(_component_el_popconfirm, {
                      key: 2,
                      "popper-class": "pay-pop",
                      title: _unref(t)('是否确认取消'),
                      onConfirm: ($event: any) => (applyCancel(scope.row))
                    }, {
                      reference: _withCtx(() => [
                        _createVNode(_component_table_button, {
                          title: _unref(t)('申请取消')
                        }, null, 8, ["title"])
                      ]),
                      _: 2
                    }, 1032, ["title", "onConfirm"]))
                  : _createCommentVNode("", true),
                _createVNode(AppLink, {
                  to: _unref(useRtfix)('ShippingInfo', { query: { deliveryTaskCode: scope.row.deliveryTaskCode } })
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_table_button, {
                      title: _unref(t)('详情')
                    }, null, 8, ["title"])
                  ]),
                  _: 2
                }, 1032, ["to"]),
                (scope.row.deliveryStatus == 5 && scope.row.sign == 0)
                  ? (_openBlock(), _createBlock(_component_el_popconfirm, {
                      key: 3,
                      "popper-class": "pay-pop",
                      title: _unref(t)('是否确认签收？'),
                      onConfirm: ($event: any) => (sign(scope.row))
                    }, {
                      reference: _withCtx(() => [
                        _createVNode(_component_table_button, {
                          title: _unref(t)('确认签收')
                        }, null, 8, ["title"])
                      ]),
                      _: 2
                    }, 1032, ["title", "onConfirm"]))
                  : _createCommentVNode("", true),
                (scope.row.deliveryStatus == 5 && scope.row.sign == 1)
                  ? (_openBlock(), _createBlock(_component_table_button, {
                      key: 4,
                      title: _unref(t)('已签收'),
                      disabled: true
                    }, null, 8, ["title"]))
                  : _createCommentVNode("", true),
                (scope.row.deliveryStatus == 5 && !_unref(isD2C)())
                  ? (_openBlock(), _createBlock(_component_table_button, {
                      key: 5,
                      title: _unref(t)('申请售后'),
                      onClick: ($event: any) => (afterSale(scope.row))
                    }, null, 8, ["title", "onClick"]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          }, 8, ["page-data", "api", "columns", "filterData", "tableConfig"])),
      _createVNode(AfterSalesDialog, {
        visible: afterSaleVisible.value,
        "onUpdate:visible": _cache[6] || (_cache[6] = ($event: any) => ((afterSaleVisible).value = $event)),
        rowItem: rowItem.value,
        dataList: dataList.value,
        onRefresh: refreshTable
      }, null, 8, ["visible", "rowItem", "dataList"]),
      _createVNode(TrackDialog, {
        visible: trackVisible.value,
        "onUpdate:visible": _cache[7] || (_cache[7] = ($event: any) => ((trackVisible).value = $event)),
        rowItem: rowItem.value,
        isJPWorder: rowItem.value.wareCode === _unref(jpWareInfo).warehouseCode,
        onRefresh: refreshTable
      }, null, 8, ["visible", "rowItem", "isJPWorder"]),
      _createVNode(_component_el_dialog, {
        modelValue: createTypeVisible.value,
        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((createTypeVisible).value = $event)),
        "custom-class": "createTypeVisible",
        "destroy-on-close": ""
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_16, _toDisplayString(_unref(t)('配送')), 1),
          _createElementVNode("div", _hoisted_17, [
            (_unref(isMultiStore)())
              ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                  _createVNode(_component_a_space, null, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_19, _toDisplayString(_unref(t)('货品仓库')), 1),
                      _createVNode(_component_el_radio_group, {
                        modelValue: wareType.value,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((wareType).value = $event))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_radio, { label: "CN" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref(t)('中国仓')), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_radio, { label: "KR" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref(t)('韩国仓')), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true),
            (isAmazon.value)
              ? (_openBlock(), _createBlock(_component_el_radio_group, {
                  key: 1,
                  modelValue: createType.value,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((createType).value = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_radio, { label: 1 }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)('通过FBA补货计划发货')), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_radio, { label: 2 }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)('普通发货')), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"]))
              : _createCommentVNode("", true),
            (createType.value === 2)
              ? (_openBlock(), _createBlock(_component_el_radio_group, {
                  key: 2,
                  modelValue: sendType.value,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((sendType).value = $event)),
                  style: {"padding":"10px 0"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_radio, { label: 2 }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)('乐天')), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_radio, { label: 3 }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)('SHOPLIST')), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_radio, { label: 4 }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)('ZOZOTOWN')), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_radio, { label: 0 }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)('其他')), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"]))
              : _createCommentVNode("", true),
            _createElementVNode("p", _hoisted_20, _toDisplayString(_unref(t)('店铺')) + ": " + _toDisplayString(_unref(customerShopName)), 1),
            _createElementVNode("div", _hoisted_21, [
              _createVNode(_component_el_button, {
                onClick: _cache[11] || (_cache[11] = ($event: any) => (createTypeVisible.value = false))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('取消')), 1)
                ]),
                _: 1
              }),
              (createType.value !== 1)
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 0,
                    type: "primary",
                    onClick: chooseCall
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('确认')), 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (createType.value === 1)
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 1,
                    type: "primary",
                    onClick: _cache[12] || (_cache[12] = ($event: any) => (_unref(router).push(_unref(useRtfix)('CreateReplenishment', { params: { wareType: wareType.value } }))))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('确认')), 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(UploadDialog, {
        ref: (_value, _refs) => {
          _refs['uploadDialog'] = _value
          uploadDialog.value = _value
        },
        onSubmit: refreshTable
      }, null, 512),
      (!_unref(isD2C)())
        ? (_openBlock(), _createBlock(Guide, {
            key: 4,
            name: "shipping-list"
          }))
        : _createCommentVNode("", true),
      _createVNode(BatchSearch)
    ], 2),
    (orderVisible.value)
      ? (_openBlock(), _createBlock(ProblemHandlingOrder, {
          key: 1,
          onCloseDialog: changeOrderVisible,
          title: _unref(t)('问题处理'),
          visible: orderVisible.value,
          "onUpdate:visible": _cache[14] || (_cache[14] = ($event: any) => ((orderVisible).value = $event)),
          rowItem: toRaw(rowItem.value),
          confirmType: confirmType.value,
          onRefresh: refreshTable
        }, null, 8, ["title", "visible", "rowItem", "confirmType"]))
      : _createCommentVNode("", true),
    (resultVisible.value)
      ? (_openBlock(), _createBlock(ProblemHandlingResult, {
          key: 2,
          onCloseDialog: changeresultVisible,
          title: _unref(t)('提示'),
          visible: resultVisible.value,
          "onUpdate:visible": _cache[15] || (_cache[15] = ($event: any) => ((resultVisible).value = $event)),
          resultData: toRaw(resultData.value),
          onRefresh: refreshTable
        }, null, 8, ["title", "visible", "resultData"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})